﻿window.cObjetEmailBounceExterneMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "email bounce"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouvelle bounce"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') {
            txt = objet.data.adresse_email
        } else {
            txt = "bounce"
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "5px" }

    this.mGetIcone = function (dataTemplate) {
        var dataIco = objet.data
        if (typeof dataTemplate != 'undefined') dataIco = dataTemplate
        if (typeof dataIco == "undefined") {
            return $("<i class='fas fa-ghost' title='Email en bounce'></i>");
        } else {
            if (dataIco.hard_bounce == "1") { return $("<i class='fas fa-ghost' title='Email en HARD bounce' style='color:red'></i>"); }
            else { return $("<i class='fas fa-ghost' title='Email en SOFT bounce' style='opacity:0.3'></i>"); }
        }
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();

    }

    this.contentTemplatePopup = function (contentElement, option) {

    }

    this.hasScrollPopup = function () { return false }
    this.isPopupFullScreen = false
    //this.mShowPopup = function (optionPopup) {
    //    page.mAddPopup(objet.data)
    //}

}